import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAtFlag = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M49.9999 19.2307H0V9.48886C0 9.02773 0.386034 8.65381 0.862108 8.65381H49.1379C49.614 8.65381 50 9.02773 50 9.48886L49.9999 19.2307Z",
			fill: "#CD343C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M49.1379 41.346H0.862109C0.386035 41.346 0 40.972 0 40.5109V30.769H50V40.5109C50 40.9721 49.614 41.346 49.1379 41.346Z",
			fill: "#CD343C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M50 19.231H0V29.8079H50V19.231Z",
			fill: "#F3F3F3"
		})
	]
});
const ForwardRef = forwardRef(SvgAtFlag);
export { ForwardRef as ReactComponent };
